import { Link } from 'react-router-dom'

function getOperator() {
  const name = import.meta.env.VITE_OPERATOR_NAME as string | undefined
  const address = import.meta.env.VITE_OPERATOR_ADDRESS as string | undefined

  return {
    name: name && name.trim().length > 0 ? name.trim() : '[Nom de l’opérateur]',
    address:
      address && address.trim().length > 0 ? address.trim() : '[Adresse postale de l’opérateur]',
  }
}

export default function Privacy() {
  const operator = getOperator()

  return (
    <main className="page" style={{ padding: '56px 24px 96px' }}>
      <div style={{ maxWidth: 860, margin: '0 auto' }}>
        <p
          style={{
            margin: 0,
            fontSize: 13,
            letterSpacing: '.14em',
            textTransform: 'uppercase',
            color: 'var(--muted)',
          }}
        >
          Politique de confidentialité
        </p>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontStyle: 'italic',
            fontWeight: 400,
            fontSize: 'clamp(34px, 5vw, 56px)',
            lineHeight: 1.08,
            margin: '14px 0 10px',
          }}
        >
          Confidentialité
        </h1>
        <p
          style={{
            margin: '0 0 28px',
            color: 'color-mix(in oklab, var(--ink) 72%, transparent)',
            fontSize: 17,
          }}
        >
          Nous n’utilisons pas de cookies de suivi. Nous collectons uniquement les données
          nécessaires au fonctionnement de votre liste de naissance.
        </p>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            1. Responsable du traitement
          </h2>
          <p style={{ margin: 0 }}>
            Le responsable du traitement est <strong>{operator.name}</strong>, {operator.address}.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            2. Données collectées
          </h2>
          <ul style={{ margin: '0 0 0 18px', padding: 0 }}>
            <li>
              <strong>Comptes propriétaires</strong> : email, nom d’affichage (si fourni), sessions.
            </li>
            <li>
              <strong>Listes</strong> : titre, date éventuelle, contenu (objets, prix, descriptions,
              images).
            </li>
            <li>
              <strong>Modes de paiement</strong> : chaînes de texte de présentation (IBAN, Lydia,
              Wero, PayPal) — chiffrées au repos côté serveur.
            </li>
            <li>
              <strong>Participations</strong> : nom et email du contributeur, montant, message
              (facultatif), item concerné.
            </li>
          </ul>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            3. Finalités et base légale
          </h2>
          <ul style={{ margin: '0 0 0 18px', padding: 0 }}>
            <li>
              <strong>Fournir le service</strong> (création, hébergement, mise à jour de la liste) —
              exécution du contrat.
            </li>
            <li>
              <strong>Sécuriser le service</strong> (prévention de la fraude, journaux techniques) —
              intérêt légitime.
            </li>
            <li>
              <strong>Communication transactionnelle</strong> (emails de connexion, notifications de
              participation) — exécution du contrat.
            </li>
          </ul>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            4. Cookies
          </h2>
          <p style={{ margin: 0 }}>
            Nous utilisons uniquement un cookie strictement nécessaire à l’authentification (cookie
            de session{' '}
            <code
              style={{
                padding: '2px 6px',
                border: '1px solid color-mix(in oklab, var(--ink) 12%, transparent)',
                borderRadius: 4,
                background: 'color-mix(in oklab, var(--bg) 92%, var(--ink))',
              }}
            >
              __session
            </code>
            ). Aucun cookie publicitaire ou de suivi n’est utilisé.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            5. Durée de conservation
          </h2>
          <p style={{ margin: 0 }}>
            Les données sont conservées jusqu’à suppression du compte par le propriétaire, ou après
            24 mois d’inactivité. Les journaux techniques peuvent être conservés sur une durée plus
            courte à des fins de sécurité.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            6. Suppression du compte
          </h2>
          <p style={{ margin: 0 }}>
            Vous pouvez supprimer votre compte depuis votre espace (
            <Link to="/me/account">Mon compte</Link>) via l’action “Supprimer mon compte”, qui
            appelle l’endpoint{' '}
            <code
              style={{
                padding: '2px 6px',
                border: '1px solid color-mix(in oklab, var(--ink) 12%, transparent)',
                borderRadius: 4,
                background: 'color-mix(in oklab, var(--bg) 92%, var(--ink))',
              }}
            >
              DELETE /me
            </code>
            .
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            7. Contact
          </h2>
          <p style={{ margin: 0 }}>
            Pour toute question, contactez-nous à{' '}
            <a href="mailto:privacy@listedenaissance.app">privacy@listedenaissance.app</a>.
          </p>
        </section>

        <hr
          style={{
            border: 0,
            borderTop: '1px solid color-mix(in oklab, var(--ink) 12%, transparent)',
            margin: '44px 0 18px',
          }}
        />
        <p style={{ margin: 0, fontSize: 13, color: 'var(--muted)' }}>
          <Link to="/">Retour à l’accueil</Link> · <Link to="/terms">Conditions</Link>
        </p>
      </div>
    </main>
  )
}
